module.exports = __webpack_public_path__ + "static/img/logo-dark2.6d949cb.png";


//////////////////
// WEBPACK FOOTER
// ./~/wb-nav/logo-dark2.png
// module id = 265
// module chunks = 2